import React, { useState, useEffect, useRef, useMemo } from "react"
import useKeypress from "../hooks/useKeyPress"
import useOnClickOutside from "../hooks/useOnClickOutside"
import { EditTwoTone } from '@mui/icons-material'
import styles from './InlineEdit.module.scss'

export default function InlineEdit(props) {
  const [isInputActive, setIsInputActive] = useState(false)
  const [inputValue, setInputValue] = useState(props.text)
  const [hoverPanelName, setHoverPanelName] = useState(false)
  const wrapperRef = useRef(null)
  const textRef = useRef(null)
  const inputRef = useRef(null)
  const enter = useKeypress("Enter")
  const esc = useKeypress("Escape")

  const hideEditPen = () => setHoverPanelName(false)
  const showEditPen = () => setHoverPanelName(true)

  // check to see if the user clicked outside of this component
  useOnClickOutside(wrapperRef, () => {
    if (isInputActive && inputValue) {
        props.onSetText(inputValue)
        setIsInputActive(false)
    } else if (isInputActive) {
      setInputValue(props.text)
      setIsInputActive(false)
    }
  })
  // focus the cursor in the input field on edit start
  useEffect(() => {
    if (isInputActive) {
      inputRef.current.focus()
    }
    return () => {}
  }, [isInputActive]) // eslint-disable-line

  useEffect(() => {
    if (isInputActive) {
      // if Enter is pressed, save the text and case the editor
      if (enter && inputValue) {
        props.onSetText(inputValue)
        setIsInputActive(false)
      }
      // if Escape is pressed, revert the text and close the editor
      if (esc || !inputValue) {
        setInputValue(props.text)
        setIsInputActive(false)
      }
    }
    return () => {}
  }, [enter, esc]) // eslint-disable-line

  useEffect(() => {
    setInputValue(props.text)
    return () => {}
  }, [props.text])

  const size = useMemo(() => props?.fontSize ?? 14 ,[props.fontSize])

  return (
    <span className={styles["inline-text"]} ref={wrapperRef} onMouseEnter={showEditPen} onMouseLeave={hideEditPen}>
      <span
        ref={textRef}
        onClick={() => setIsInputActive(true)}
        className={`${[styles[`inline-text_copy`], props?.extraClassname].join(' ')} ${styles[`inline-text_copy--${!isInputActive ? "active" : "hidden"}`]}`}
        style={{fontSize: `${size}px`}}
      >
        {inputValue}
      </span>
      <input
        ref={inputRef}
        // set the width to the input length multiplied by the x height
        // it's not quite right but gets it close
        style={{fontSize: `${size}px` ,width: Math.min(Math.max(inputValue.length * size, 100), window.innerWidth*70/100) + "px"}}
        value={inputValue}
        onChange={(e) => { setInputValue(e.target.value) }}
        maxLength={props.maxLength || 100}
        className={`${[styles[`inline-text_input`], props?.extraClassname].join(' ')} ${styles[`inline-text_input--${isInputActive ? "active" : "hidden"}`]}`}
      />
      {hoverPanelName && !isInputActive && <EditTwoTone classes={{root: styles['pen']}} color="textSecondary"/>}
    </span>
  )
}